import { ExternalLinkIcon } from "../../icons";
import { cn } from "../../utils/class-names";
import { UnstyledLink } from "../link";

interface ExternalLinkProps {
  className?: string;
  href: string;
}

export function ExternalLink({
  className,
  href,
}: ExternalLinkProps): JSX.Element {
  return (
    <UnstyledLink
      external
      className={cn("text-shale-400", className)}
      href={href}
    >
      <ExternalLinkIcon className="w-4 h-4" />
    </UnstyledLink>
  );
}
